import { render, staticRenderFns } from "./JpServiceCards.vue?vue&type=template&id=54781490&scoped=true&"
import script from "./JpServiceCards.vue?vue&type=script&lang=js&"
export * from "./JpServiceCards.vue?vue&type=script&lang=js&"
import style0 from "./JpServiceCards.vue?vue&type=style&index=0&id=54781490&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54781490",
  null
  
)

export default component.exports